var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.3234C14.2564 7.3234 15.275 6.11084 15.275 4.61507C15.275 3.1193 14.2564 1.90674 13 1.90674C11.7435 1.90674 10.725 3.1193 10.725 4.61507C10.725 6.11084 11.7435 7.3234 13 7.3234Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8309 23.7252C23.7359 24.8952 22.9884 20.4752 19.6192 20.161C15.4701 19.7494 13.1951 24.0935 8.27672 24.0935C1.23505 24.0935 3.78089 17.431 10.9851 21.1035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0533 12.7939C10.4165 13.671 10.5722 14.6201 10.5083 15.5673C10.4216 16.8348 9.57664 17.6039 9.05664 18.8173",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9466 12.7939C15.5835 13.671 15.4277 14.6201 15.4916 15.5673C15.5783 16.8348 16.4233 17.6039 16.9433 18.8173",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6816 8.7749C10.6058 8.88324 7.06329 8.56907 7.73496 13.3466C8.23329 16.8891 6.99829 17.2682 5.41663 18.5249",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3184 8.7749C15.3942 8.88324 18.9367 8.56907 18.265 13.3466C17.7667 16.8891 19.0017 17.2682 20.6159 18.5249",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.cb7fb46e9d1bce7fa2e436b2a3707c42.svg";
export { ForwardRef as ReactComponent };